import { TextEncoder, TextDecoder } from 'text-encoding';
var UtilsService = (function () {
    function UtilsService() {
        this.key = "X9v$G7!bK2pQ#rLm";
    }
    /* Parse response using data id as array key */
    UtilsService.prototype.parseResponse = function (data) {
        var parseArray = [];
        for (var i = 0; i < data.details.length; i++) {
            parseArray[data.details[i].name] = data.details[i].value;
        }
        return parseArray;
    };
    /* Easy Javascript's localStorage */
    UtilsService.prototype.localStorage = function (option, name, content) {
        if (content === void 0) { content = null; }
        switch (option) {
            case "get":
                return localStorage.getItem(name);
            case "post":
                localStorage.setItem(name, content);
                break;
            case "delete":
                localStorage.removeItem(name);
                break;
        }
    };
    /* Parse a string to json */
    UtilsService.prototype.toJson = function (string) {
        return JSON.parse(string);
    };
    /* Parse a json to string */
    UtilsService.prototype.toString = function (json) {
        return JSON.stringify(json);
    };
    /* Get wait time in hh:mm:ss */
    UtilsService.prototype.getWaitTime = function (sdate, edate, revert, withSeconds) {
        if (edate === void 0) { edate = null; }
        if (revert === void 0) { revert = false; }
        if (withSeconds === void 0) { withSeconds = true; }
        if (typeof sdate == "undefined" || sdate == null) {
            if (withSeconds) {
                return "00:00:00";
            }
            else {
                return 0;
            }
        }
        else {
            sdate = (revert) ? this.parseDate(sdate, true) : this.parseDate(sdate);
            var startDate = new Date(sdate);
            var endDate = void 0;
            if (edate == null || typeof edate == "undefined") {
                endDate = new Date();
            }
            else {
                edate = (revert) ? this.parseDate(edate, true) : this.parseDate(edate);
                endDate = new Date(edate);
            }
            var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
            if (withSeconds) {
                return this.secondsToHms(seconds);
            }
            else {
                var result = Math.round(seconds / 60);
                if (result == null) {
                    return 0;
                }
                else {
                    return result;
                }
            }
        }
    };
    /* Parse date: dd/mm/yyyy hh:mm:ss to yyyy-mm-ddThh:mm:ss */
    UtilsService.prototype.parseDate = function (date, revert) {
        if (revert === void 0) { revert = false; }
        var cut = date.split(" ");
        var d = (revert) ? cut[1] : cut[0];
        var parseDate = d.split("-");
        var h = (revert) ? cut[0] : cut[1];
        var dateParsed = parseDate[0] + "-" + parseDate[1] + "-" + parseDate[2] + "T" + h;
        return dateParsed;
    };
    /* Convert seconds in hh:mm:ss */
    UtilsService.prototype.secondsToHms = function (seconds) {
        var h = Math.floor(seconds / 3600);
        if (h < 10)
            h = '0' + h;
        var m = Math.floor(seconds % 3600 / 60);
        if (m < 10)
            m = '0' + m;
        var s = Math.floor(seconds % 3600 % 60);
        if (s < 10)
            s = '0' + s;
        return h + ":" + m + ":" + s;
    };
    UtilsService.prototype.initializeTooltip = function () {
        $(document).ready(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    };
    UtilsService.prototype.convertToPlainText = function (input) {
        if (!/<[^>]*>/g.test(input))
            return input;
        var withLineBreaks = input.replace(/<br\s*\/?>/g, '\n');
        var div = document.createElement("div");
        div.innerHTML = withLineBreaks;
        return div.innerText;
    };
    UtilsService.prototype.stringToBytes = function (str) { return new TextEncoder().encode(str); };
    UtilsService.prototype.bytesToString = function (bytes) { return new TextDecoder().decode(bytes); };
    UtilsService.prototype.xorBytes = function (data, key) {
        var keyBytes = this.stringToBytes(key);
        var out = new Uint8Array(data.length);
        for (var i = 0; i < data.length; i++) {
            out[i] = data[i] ^ keyBytes[i % keyBytes.length];
        }
        return out;
    };
    UtilsService.prototype.base64FromBytes = function (bytes) {
        var binary = '';
        for (var i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    };
    UtilsService.prototype.bytesFromBase64 = function (b64) {
        var binary = atob(b64);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    };
    UtilsService.prototype.obfuscate = function (text) {
        var inverted = text.split('').reverse().join('');
        var xored = this.xorBytes(this.stringToBytes(inverted), this.key);
        return this.base64FromBytes(xored);
    };
    UtilsService.prototype.deobfuscate = function (obfBase64) {
        var bytes = this.bytesFromBase64(obfBase64);
        var xored = this.xorBytes(bytes, this.key);
        var inverted = this.bytesToString(xored);
        return inverted.split('').reverse().join('');
    };
    return UtilsService;
}());
export { UtilsService };
